import { render, staticRenderFns } from "./titleTextBlock.vue?vue&type=template&id=88080c6e&"
import script from "./titleTextBlock.vue?vue&type=script&lang=js&"
export * from "./titleTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./titleTextBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports